import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { AlertTriangle } from "lucide-react";
import { api, messageErreur } from "@/lib/api";
import { formatEuros } from "@/lib/format";

const Relance = ({ t, resultats, onFait }) => {
  const [ouvert, setOuvert] = useState(false);
  const noter = (r) => api.post(`/relances-devis/${t.id}`, { resultat: r }).then(() => { toast.success(`Relance notée : ${resultats[r]}.`); onFait(); }).catch((e) => toast.error(messageErreur(e)));
  return (
    <div className="at-card p-3 space-y-2" style={t.en_retard ? { border: "2px solid var(--danger)" } : undefined} data-testid={`quote-reminder-${t.id}`}>
      <div className="flex items-center justify-between gap-2">
        <Link to={`/fiches/${t.fiche_id}`} className="min-w-0 min-h-[44px] flex flex-col justify-center"><span className="font-semibold truncate">{t.fiche_nom}</span><span className="text-xs at-muted">{t.note} · {new Date(t.echeance).toLocaleDateString("fr-FR")} · {formatEuros(t.montant)}</span></Link>
        <button type="button" onClick={() => setOuvert(!ouvert)} className="at-btn at-btn-primary shrink-0 !px-3 text-sm" data-testid={`quote-reminder-note-${t.id}`}>Résultat</button>
      </div>
      {ouvert && <div className="grid grid-cols-2 gap-2">{Object.entries(resultats).map(([k, l]) => <button key={k} type="button" onClick={() => noter(k)} className="at-btn at-btn-ghost !px-2 text-sm" data-testid={`quote-reminder-${t.id}-${k}`}>{l}</button>)}</div>}
    </div>
  );
};

export function DevisSansRelance({ complet = false }) {
  const [d, setD] = useState(null);
  const charger = useCallback(() => api.get("/relances-devis").then((r) => setD(r.data)).catch(() => {}), []);
  useEffect(() => { charger(); }, [charger]);
  if (!d) return null;
  return (
    <div className="space-y-3 mb-6 min-w-0">
      <section className="space-y-2 p-3" style={{ background: "color-mix(in srgb, var(--danger) 10%, transparent)", borderRadius: 20 }} data-testid="quotes-without-reminder">
        <p className="font-bold flex items-center gap-2" style={{ color: "var(--danger)" }}><AlertTriangle size={16} />Devis sans relance ({d.sans_relance.length})</p>
        {d.sans_relance.length === 0 && <p className="text-sm at-muted" data-testid="quotes-without-reminder-empty">Aucun devis en attente de relance</p>}
        {d.sans_relance.map((t) => <Relance key={t.id} t={t} resultats={d.resultats} onFait={charger} />)}
      </section>
      {complet && (
        <section className="space-y-2" data-testid="quotes-upcoming-reminders">
          <p className="font-bold">Relances à venir ({d.a_venir.length})</p>
          {d.a_venir.length === 0 && <p className="text-sm at-muted">Aucune relance programmée.</p>}
          {d.a_venir.map((t) => <Relance key={t.id} t={t} resultats={d.resultats} onFait={charger} />)}
        </section>
      )}
    </div>
  );
}

export default function Devis() {
  return (
    <div className="min-w-0 space-y-4" data-testid="page-devis">
      <h1 className="text-4xl sm:text-5xl font-bold tracking-tight" data-testid="page-title">Devis</h1>
      <p className="at-muted">Relances après devis (J+3, J+7, J+14) : le commercial du cabinet relance même si le devis vient du partenaire.</p>
      <DevisSansRelance complet />
    </div>
  );
}
